<template>

  <vs-row vs-type="flex" vs-justify="center">
    <vs-col vs-lg="10" vs-sm="12" vs-xs="12" style="padding:0">
      <vx-card :title="operation.idThunders.concat(' - ', operation.clientName)">
        <vs-table stripe :data="operation.contracts" noDataText="Não há balanços cadastrados">
          <template slot="header">
            <h3 class="mb-4"></h3>
          </template>

          <template slot="thead">
            <th>
              <button name="button" @click="activePrompt = !activePrompt" class="ml-3 vs-component vs-button vs-button-primary vs-button-filled includeIcon includeIconOnly vs-radius">
              <feather-icon icon="PlusIcon" svgClasses="w-4 h-4"></feather-icon>
            </button>
            </th>
            <th>Tipo de Garantia</th>
            <th>Valor da Garantia</th>
            <th>Data da Contratação</th>
            <th>Data Inicial da Garantia</th>
            <th>Data de Vencimento</th>
            <th>Meses de Cobertura</th>
            <th>Instituição Garantidora</th>
            <th>Criado por</th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <td>

              </td>
              <td>
                {{row.guaranteeType | formatGuarantee}}
              </td>
              <td>
                {{row.guaranteeAmount | toDecimal}}
              </td>
              <td>
                {{row.startDate | formatDate}}
              </td>
              <td>
                {{row.contractDate | formatDate}}
              </td>
              <td>
                {{row.dueDate | formatDate}}
              </td>
              <td>
                {{row. monthCoverage}}
              </td>
              <td>
                {{row.financialInstitution.company.name}}
              </td>
              <td>
                {{row.createdByStr}}
              </td>
            </vs-tr>
          </template>

        </vs-table>
      </vx-card>

      <div class="vx-row mt-4">
        <div class="vx-col">
          <vs-button @click="back">Voltar</vs-button>
        </div>
      </div>

    </vs-col>

    <vs-prompt
      @accept="addContract"
      @close="close"
      title="Novo Contrato"
      accept-text="Adicionar"
      :is-valid="validate"
      :active.sync="activePrompt">

      <div class="grid grid-rows-6 gap-2">
        <div>
          <vs-select
            label="Tipo de garantia"
            name="tipo de garantia"
            v-validate="'required'"
            v-model="contract.guaranteeType"
            class="w-full">
            <vs-select-item :key="index" :value="item.value" :text="item.description" v-for="(item,index) in guaranteeTypes" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors.has('tipo de garantia')">{{ errors.first('tipo de garantia') }}</span>
        </div>

        <div>
          <NumericInput
            label="Valor da garantia"
            name="valor da garantia"
            v-validate="'required'"
            minimumFractionDigits="2"
            placeholder="Valor da Garantia"
            v-model="contract.guaranteeAmount"
            class="w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('valor da garantia')">{{ errors.first('valor da garantia') }}</span>
        </div>

        <div>
          <label>Data de Contração</label>
          <date-picker
            name="data de contratação"
            v-validate="'required'"
            :append-to-body="false"
            format="DD-MM-YYYY"
            value-type="YYYY-MM-DD"
            v-model="contract.startDate"
            class="w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('data de contratação')">{{ errors.first('data de contratação') }}</span>
        </div>

        <div>
          <label>Data Inicial da Garantia</label>
          <date-picker
            name="data inicial da garantia"
            v-validate="'required'"
            :append-to-body="false"
            format="DD-MM-YYYY"
            value-type="YYYY-MM-DD"
            v-model="contract.contractDate"
            class="w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('data inicial da garantia')">{{ errors.first('data inicial da garantia') }}</span>
        </div>

        <div>
          <label>Data de Vencimento</label>
          <date-picker
            name="data de vencimento"
            v-validate="'required'"
            :append-to-body="false"
            format="DD-MM-YYYY"
            value-type="YYYY-MM-DD"
            v-model="contract.dueDate"
            class="w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('data de vencimento')">{{ errors.first('data de vencimento') }}</span>
        </div>

        <div>
          <NumericInput
            label="Meses de Cobertura"
            name="meses de cobertura"
            minimumFractionDigits="0"
            v-validate="'required'"
            placeholder="Meses de Garantia"
            v-model="contract.monthCoverage"
            class="w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('meses de garantia')">{{ errors.first('meses de garantia') }}</span>
        </div>

        <div>
          <vs-select
            label="Nome da Instituição Garantidora"
            name="nome instituição garantidora"
            v-validate="'required'"
            v-model="contract.financInstituteDto.guid"
            :autocomplete="true"
            class="w-full">
            <vs-select-item :key="index" :value="item.guid" :text="item.name" v-for="(item,index) in financInstitutions" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors.has('nome instituição garantidora')">{{ errors.first('nome instituição garantidora') }}</span>
        </div>

        <div>
          <vs-select
            label="Cnpj da Instituição Garantidora"
            name="cnpj instituição garantidora"
            v-validate="'required'"
            v-model="contract.financInstituteDto.guid"
            :autocomplete="true"
            class="w-full">
            <vs-select-item :key="index" :value="item.guid" :text="(item.cnpjAlfa || item.cnpj) | formatCnpj" v-for="(item,index) in financInstitutions" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors.has('cnpj instituição garantidora')">{{ errors.first('cnpj instituição garantidora') }}</span>
        </div>

        <div>
          <vs-alert :active="!validate" color="danger" icon="new_releases" >
            Preencha todos os campos obrigatórios
          </vs-alert>
        </div>

      </div>
    </vs-prompt>

  </vs-row>
</template>

<script>
import axios from 'axios';
import NumericInput from "@/components/NumericInput";
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import UserAuthorization from "@/mixins/UserAuthorization";

export default {
  name: "GarantiaView",
  mixins:[UserAuthorization],
  props: {
    guid: String
  },
  components: {
    NumericInput,
    DatePicker
  },
  data () {
    return {
      activePrompt: false,
      operation: {
        clientName: '',
        idThunders: '',
        contracts: []
      },
      guaranteeType: '',
      guaranteeTypes: [],
      financInstitutions: [],
      contract: {
        guaranteeType: '',
        guaranteeAmount: '',
        startDate: '',
        contractDate: '',
        dueDate: '',
        monthCoverage: '',
        financInstituteDto: {
          name: null,
          cnpj: null,
          guid: null
        }
      }
    }
  },
  beforeMount() {
    this.loadOperation()
    this.loadGuaranteeTypes()
    this.loadFinancialInstitutes()
  },
  computed: {
    validate () {
      return this.contract.guaranteeType !== '' &&
        this.contract.guaranteeAmount !== '' &&
        this.contract.dueDate !== '' &&
        this.contract.monthCoverage !== '' &&
        this.contract.financInstituteDto.guid !== null
    }
  },
  methods: {
    loadOperation () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/guarantee/${this.guid}`)
        .then((response) => {
          this.operation = response.data
        })
    },

    loadGuaranteeTypes () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/guarantee-types`)
        .then((response) => {
          this.guaranteeTypes = response.data
        })
    },

    addContract () {
      axios.post(`${process.env.VUE_APP_API}/api/v1/guarantee-contract/${this.guid}`, this.contract)
      .then((response) => {
        this.guarantee = response.data
      })
      .finally(() => {
        this.loadOperation()
      })
    },

    loadFinancialInstitutes () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/financ-institutes`)
        .then((response) => {
          this.financInstitutions = response.data
        })
    },

    back () {
      this.$router.push({path: '/guarantee'})
    }
  }
}
</script>

<style scoped>

</style>
